import * as React from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import 'assets/css/fonts.css';
import './index.css';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Missing root element');
}

createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
